import React from "react";
import { Link } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";

const FAQ_TEXT_LINK_PATTERN = /(frequently asked questions|sign in|resources)/gi;

const getRouteForMatch = (value) => {
  const normalizedValue = (value || "").toLowerCase();

  if (normalizedValue === "sign in") {
    return "/sign-in";
  }

  if (normalizedValue === "resources") {
    return "/resources";
  }

  if (normalizedValue === "frequently asked questions") {
    return "/#faq-section";
  }

  return null;
};

export const renderFaqTextWithLinks = (value) => {
  const textValue = typeof value === "string" ? value : "";

  if (!textValue) {
    return "";
  }

  return textValue.split(FAQ_TEXT_LINK_PATTERN).map((segment, index) => {
    const route = getRouteForMatch(segment);

    if (!route) {
      return <React.Fragment key={`faq-text-${index}`}>{segment}</React.Fragment>;
    }

    return (
      <Link
        as={RouterLink}
        to={route}
        key={`faq-link-${index}`}
        color="blue.600"
        textDecoration="underline"
        _hover={{ color: "blue.700" }}
      >
        {segment}
      </Link>
    );
  });
};
